import React from 'react';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import {getStoredData} from "../../JsonFiles/fetchData";

const AddProductsPage = () => {
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminProducts : {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/products'; // API endpoint for creating product
  const successRedirect = '/admin/products'; // Redirect after successful product creation

  return (
    <div>
      <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
    </div>
  );
};


export default AddProductsPage;
